import { render, staticRenderFns } from "./CheckboxCustomField.vue?vue&type=template&id=477b8596&"
import script from "./CheckboxCustomField.vue?vue&type=script&lang=ts&"
export * from "./CheckboxCustomField.vue?vue&type=script&lang=ts&"
import style0 from "./CheckboxCustomField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol})
